// msalInstance.js
import { PublicClientApplication } from "@azure/msal-browser";
import { logoutRequest, msalConfig } from "../../authConfig";
import { removeItem } from "../services/storage-service";
import logger from "../../helpers/logger";

export const msalInstance = new PublicClientApplication(msalConfig);

export const logoutUser = async () => {
    try {
        removeItem("UserProfile");
        await msalInstance.logoutRedirect(logoutRequest);
    } catch (error) {
        logger.error("Logout failed:", error);
    }
};